import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";
import CustomTooltip from "../../../../components/charts/CustomToolTip";
import Legends from "../../../../components/legends/Legends";
import NoData from "../../../../components/noData/Nodata";
import TileBox from "../../../../components/tile/TileBox";
import { capitalizeWords } from "../../../../utils/helpers";

const StatusReport = ({ data }) => {
  const theme = useTheme();
  const isEmpty = Boolean(!Object.keys(data).length);
  const keys = isEmpty ? [] : Object.keys(data);
  const { success, error, info, warning, primary, secondary } = theme.palette;

  const colors = {
    PLAN_RUNNING: info.light,
    IN_PROGRESS: primary.main,
    COMPLETED: success.main,

    FAILED: error.dark,
    APPLY_FAILED: error.main,
    REJECTED: success.light,
    REJECT_FAILED: error.light,

    TERMINATE_IN_PROGRESS: secondary.light,
    TERMINATE_PLAN_FAILED: warning.main,
    TERMINATED: secondary.dark,
    TERMINATE_FAILED: warning.dark,
  };

  const graphData = isEmpty
    ? null
    : keys.map((key) => {
        return {
          name: capitalizeWords(key),
          value: data[key] || 0,
          color: colors[key],
        };
      });

  const legendsData = isEmpty
    ? null
    : keys.map((key) => {
        return {
          name: `${capitalizeWords(key)} (${data[key]})`,
          value: data[key] || 0,
          color: colors[key],
        };
      });

  return (
    <TileBox title="Status">
      <Box
        sx={{
          "::-webkit-scrollbar": {
            display: "none",
          },
        }}
        width={"100%"}
        height={"315px"}
        overflow={"auto"}
      >
        {graphData ? (
          <>
            <ResponsiveContainer width="100%" height="85%">
              <PieChart>
                <Pie
                  data={graphData}
                  dataKey="value"
                  cx="50%"
                  cy="50%"
                  innerRadius={"50%"}
                  outerRadius={"80%"}
                  labelLine={false}
                  paddingAngle={1}
                  cornerRadius={4}
                  label
                >
                  {graphData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={entry.color} />
                  ))}
                </Pie>
                <Tooltip content={<CustomTooltip />} />
              </PieChart>
            </ResponsiveContainer>
            <Legends sx={{ display: "flex" }} legends={legendsData} />
          </>
        ) : (
          <NoData />
        )}
      </Box>
    </TileBox>
  );
};

export default StatusReport;
